import type { Theme } from "@mui/material/styles";
import mermaid from "mermaid";

const FLOWCHART_BASE = {
  curve: "basis",
  padding: 20,
} as const;

/**
 * Initialize mermaid with static hardcoded colors (for infrastructure diagrams).
 * Called once at module load.
 */
export function initMermaidStatic(): void {
  mermaid.initialize({
    startOnLoad: false,
    theme: "base",
    themeVariables: {
      primaryColor: "#0066ff",
      primaryTextColor: "#fff",
      primaryBorderColor: "#0066ff",
      lineColor: "#0066ff",
      secondaryColor: "#10b981",
      tertiaryColor: "#f3f4f6",
    },
    flowchart: { ...FLOWCHART_BASE },
  });
}

/**
 * Initialize mermaid with theme-aware colors from the MUI theme.
 * Call inside a useEffect that depends on theme + isDark.
 */
export function initMermaidFromTheme(theme: Theme, padding = 15): void {
  const isDark = theme.palette.mode === "dark";
  mermaid.initialize({
    startOnLoad: false,
    theme: "base",
    themeVariables: {
      primaryColor: theme.palette.primary.main,
      primaryTextColor: "#fff",
      primaryBorderColor: theme.palette.primary.main,
      lineColor: theme.palette.divider,
      secondaryColor: theme.palette.secondary.main,
      tertiaryColor: isDark ? theme.palette.grey[800] : theme.palette.grey[100],
      mainBkg: isDark ? theme.palette.grey[900] : "#ffffff",
      nodeBorder: theme.palette.divider,
      clusterBkg: isDark ? theme.palette.grey[800] : theme.palette.grey[100],
      clusterBorder: theme.palette.divider,
      titleColor: theme.palette.text.primary,
    },
    flowchart: {
      curve: "basis",
      padding,
    },
  });
}
